module.exports = __webpack_public_path__ + "img/stand_xiaoman_curious_cut.4046acab.png";